import { Stack } from '@mui/material';

export const Filter = ({ children }) => (
  <Stack sx={{ width: 140 }}>
    {children}
  </Stack>
);
